module.exports = __webpack_public_path__ + "img/dh.0116c212.png";